import React, { useEffect, useMemo, useState } from "react";
import {
  Col,
  Container,
  Row,
  Card,
  CardBody,
  Input,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import classnames from "classnames";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import usePersistStoreData from "../../Components/Hooks/usePersistStoreData";
import { useSelector } from "react-redux";
import { home_portfolioThunk } from "../../slices/thunks";
import Home_Financial_Ledger_Skeleton from "../../Components/Skeleton/Home_Financial_Ledger_Skeleton";
import Home_Portfolio_Skeleton from "../../Components/Skeleton/Home_Portfolio_Skeleton";

const Home_Portfolio = () => {
  // document.title = "Dashboard | B.N. Rathi";

  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { userData } = usePersistStoreData();
  const token = userData?.token;
  const [selectedTime, setSelectedTime] = useState("current-fy");

  //handle investment summery filter
  const handleFilterTime = (event) => {
    const selectedValue = event.target.value;
    setSelectedTime(selectedValue);
    dispatch(
      home_portfolioThunk({
        token,
        params: { data_range: selectedValue },
      })
    );
  };

  const { home_portfolioData, home_portfolioLoading } = useSelector(
    (state) => state.Home_Portfolio
  );

  useEffect(() => {
    dispatch(
      home_portfolioThunk({
        params: { data_range: selectedTime },
        token,
      })
    );
  }, []);

  return (
    <React.Fragment>
      <div className="my-2">
        {/* <div>
          <p className="mb-0 fs-14 fw-medium text-muted">
            <i className="me-1 ri-time-line align-middle fs-14"></i>
            Updated on <span className="text-primary">{home_portfolioData?.as_on_date}</span>
          </p>
        </div> */}

        <Row className="align-items-center">
          <Col
            xxl="12"
            xl="12"
            lg="12"
            md="12"
            xs="12"
            className="mb-1 mb-xxl-0 mt-1 mt-xxl-0"
          >
            <div className="d-flex align-items-center justify-content-between flex-wrap my-1">
            <span className="text-muted fs-14 fw-medium">
              Detailed overview of your past month portfolio under different
              segments.
            </span>
            <p className="mb-0 fs-14 fw-medium text-muted">
            <i className="me-1 ri-time-line align-middle fs-14"></i>
            Updated on <span className="text-primary">{home_portfolioData?.as_on_date}</span>
          </p>
          </div>
          </Col>

          {/* <Col xxl="4" xl="6" lg="12" md="6" xs="12" className="mb-1 mb-xxl-0">
            <div className="d-flex align-items-center gap-2 justify-content-lg-end">
              <span
                className="text-dark fs-14 fw-medium"
                style={{ minWidth: "150px" }}
              >
                Select Month Range
              </span>
              <Input
                type="select"
                className="fs-12 fw-medium text-muted"
                style={{ cursor: "pointer", minWidth: "120px" }}
                onChange={handleFilterTime}
                value={selectedTime}
              >
                <option value="current-fy">Current F.Y.</option>
                <option value="last-month">Last Month</option>
                <option value="last-three-months">Last 3 Month</option>
                <option value="last-six-months">Last 6 Month</option>
              </Input>
            </div>
          </Col> */}
        </Row>
      </div>
      {/* <div className="d-flex align-items-center justify-content-between my-4 flex-wrap">
                          <span className="text-muted fs-14 fw-medium">
                            Detailed overview of your past month portfolio under
                            different segments.
                          </span>
                          <div className="d-flex align-items-center gap-2 mt-2 mt-md-0" >
                          <span className="text-dark fs-14 fw-medium"
                       style={{ minWidth: '150px' }}
                      >
                      Select Month Range
                      </span>
                            <Input
                              type="select"
                              className="fs-12 fw-medium text-muted"
                              style={{
                                cursor:"pointer",
                                minWidth: '120px'
                              }}
                              onChange={handleFilterTime}
                              value={selectedTime}
                            >
                              <option value="current-fy">Current F.Y.</option>
                              <option value="last-month">Last Month</option>
                              <option value="last-three-months">Last 3 Month</option>
                              <option value="last-six-months">Last 6 Month</option>
                            </Input>
                          </div>
                        </div> */}
      {home_portfolioLoading ? (
        <Home_Portfolio_Skeleton />
      ) : (
        <Row className="">
 {Object.entries(home_portfolioData?.response || {}).map(([key, value]) => {
    // Create a display name from the key (customize if needed)
    let displayName = "";

    if (key === "cap_data") displayName = "Capital";
    else if (key === "fo_data") displayName = "F&O";
    else displayName = key.replace(/_/g, " ").replace(/\b\w/g, l => l.toUpperCase());

            return (
              <React.Fragment key={key}>
                {/* Header card with the display name */}
                <Col xxl={3} xl={3} lg={12} md={12} sm={12} xs={12}>
                  <Card
                    className="finance_home_capital"
                    style={{
                      borderLeft: "2px solid #F1F4F7",
                      borderRight: "0",
                      borderTop: "0",
                      borderBottom: "0",
                    }}
                  >
                    <CardBody className="d-flex align-items-center">
                      <div>
                        <h3 className="text-dark m-0 mb-2">{displayName}</h3>
                        <p
                          className="fs-12 text-muted fw-semibold mb-1"
                          style={{ letterSpacing: "1px" }}
                        >
                          Portfolio
                        </p>
                      </div>
                    </CardBody>
                  </Card>
                </Col>

                {/* Net Realised */}
                <Col xxl={3} xl={3} lg={4} md={4} sm={12} xs={12}>
                  <Card className="home_finance_card border-0">
                    <CardBody className="d-flex align-items-center">
                      <div>
                        <h4 className="text-dark m-0 mb-2 text-break">
                          <span className="fs-16 fw-medium text-muted me-2">
                            ₹
                          </span>
                          {parseFloat(
                            value?.net_realised ?? "0.00"
                          ).toLocaleString("en-IN" ,{
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                            })}
                        </h4>
                        <p
                          className="fs-12 text-muted fw-semibold mb-1"
                          style={{ letterSpacing: "1px" }}
                        >
                          NET REALISED
                        </p>
                      </div>
                    </CardBody>
                  </Card>
                </Col>

                {/* Unrealised */}
                <Col xxl={3} xl={3} lg={4} md={4} sm={12} xs={12}>
                  <Card className="home_finance_card border-0">
                    <CardBody className="d-flex align-items-center">
                      <div>
                        <h4 className="text-dark m-0 mb-2 text-break">
                          <span className="fs-16 fw-medium text-muted me-2">
                            ₹
                          </span>
                          {parseFloat(
                            value?.unrealised ?? "0.00"
                          ).toLocaleString("en-IN" ,{
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                            })}
                        </h4>
                        <p
                          className="fs-12 text-muted fw-semibold mb-1"
                          style={{ letterSpacing: "1px" }}
                        >
                          UNREALISED
                        </p>
                      </div>
                    </CardBody>
                  </Card>
                </Col>

                {/* Gross P&l */}
                <Col xxl={3} xl={3} lg={4} md={4} sm={12} xs={12}>
                  <Card className="home_portfolio_card border-0">
                    <CardBody className="d-flex align-items-center">
                      <div>
                        <h4 className="text-white m-0 mb-2 text-break">
                          <span className="fs-16 fw-medium text-white me-2">
                            ₹
                          </span>
                          {parseFloat(
                            value?.gross_pnl ?? "0.00"
                          ).toLocaleString("en-IN" ,{
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                            })}
                        </h4>
                        <p
                          className="fs-12 text-white fw-semibold mb-1"
                          style={{ letterSpacing: "1px" }}
                        >
                          GROSS P&L
                        </p>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </React.Fragment>
            );
          })}
        </Row>
      )}
    </React.Fragment>
  );
};

export default Home_Portfolio;
